/**
 * Branch branding header for the customer-facing flow.
 * Shows the branch logo when one exists, otherwise the branch name as text.
 * A branch row can point at a logo file that is not on the server (404); in
 * that case fall back to the name too, so the header is never left blank.
 */
import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";

const BranchHeader = ({ logoUrl, branchName, isMobile }) => {
    const [logoFailed, setLogoFailed] = useState(false);

    // Reset when the branch (and therefore the logo) changes
    useEffect(() => {
        setLogoFailed(false);
    }, [logoUrl]);

    const showLogo = logoUrl && !logoFailed;

    return (
        <Box mb={2} textAlign="center">
            {showLogo ? (
                <img
                    src={logoUrl}
                    alt={branchName || "Branch Logo"}
                    style={{
                        width: isMobile ? 180 : 300,
                        maxWidth: "100%",
                    }}
                    onError={() => setLogoFailed(true)}
                />
            ) : branchName ? (
                <Typography
                    variant={isMobile ? "h5" : "h4"}
                    sx={{ fontWeight: "bold" }}
                >
                    {branchName}
                </Typography>
            ) : null}
        </Box>
    );
};

export default BranchHeader;
